import React from "react";
import { Navigate } from "react-router-dom";
import en_ja from "../translations/en_ja";

import Dashboard from "../pages/Dashboard";
import ClinicManagement from "../pages/ClinicManagement";
import UserManagement from "../pages/UserManagement";
import Reports from "../pages/Reports";
import Products from "../pages/Products";
import Orders from "../pages/Orders";
import Login from "../pages/login";
import UserLayout from "../layouts/UserLayout";
import Pharmacy from "../pages/Pharmacy/Pharmacy";
import Stores from "../pages/Stores";
import Profile from "../pages/Profile/Profile";
import Coupon from "../pages/Coupon/Coupon";
import Settings from "../pages/Profile/Settings";
import Notifications from "../pages/Notifications";
import BannerManagement from "../pages/BannerManagement";
import WarrantyManagement from "../pages/WarrantyManagement";
import AdminManagement from "../pages/SuperAdminManagement/AdminManagement";
import SuperAdminSettings from "../pages/Profile/SuperAdminSettings";
import DeepLinkManagement from "../pages/DeepLinkManagement";

// Public and protected layout-based route config with translations
const RoutersList = [
  {
    RouteLayout: <UserLayout />,
    ProtectRoute: true,
    RouteList: [
      { path: "/", element: <Navigate to="/dashboard" replace />, label: en_ja["Home"] },
      { path: "dashboard", element: <Dashboard />, label: en_ja["Dashboard"] },
      { path: "clinic-management", element: <ClinicManagement />, label: en_ja["Clinic Management"] },
      { path: "user-management", element: <UserManagement />, label: en_ja["User Management"] },
      { path: "reports", element: <Reports />, label: en_ja["Reports"] },
      { path: "products", element: <Products />, label: en_ja["Products"] },
      { path: "orders", element: <Orders />, label: en_ja["Orders"] },
      { path: "pharmacy-management", element: <Pharmacy />, label: en_ja["Pharmacy"] },
      { path: "stores", element: <Stores />, label: en_ja["Stores"] },
      { path: "profile", element: <Profile />, label: en_ja["Profile"] },
      { path: "settings", element: <Settings />, label: en_ja["Settings"] },
      { path: "coupon-management", element: <Coupon />, label: en_ja["Coupon Management"] },
      { path: "notifications", element: <Notifications />, label: en_ja["Notifications"] },
      { path: "banner-management", element: <BannerManagement />, label: en_ja["Banner Management"] },
      { path: "warranty-management", element: <WarrantyManagement />, label: en_ja["Warranty Management"] },
      { path: "admin-management", element: <AdminManagement />, label: en_ja["Admin Management"] },
      { path: "super-admin-settings", element: <SuperAdminSettings />, label: en_ja["Settings"] },
      { path: "deeplink-management", element: <DeepLinkManagement />, label: en_ja["Deeplink Management"] },
    ],
  },
  {
    RouteLayout: null,
    ProtectRoute: false,
    RouteList: [
      { path: "/login", element: <Login />, label: en_ja["Login"] },
    ],
  },
];

export default RoutersList;
